import React from "react";
import Background from "./Background";

const Welcome = ({ darkMode }) => {
  return (
    <section
      id="welcome"
      style={{
        position: "relative",
        width: "98vw",
        height: "100vh",
        overflow: "hidden",
      }}
    >
      {/* Background */}
      <Background />

      {/* Content */}
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          background: "gray",
          padding: "2rem",
          borderRadius: "10px",
          textAlign: "center",
          color: "#ffffff",
          boxShadow: "0 4px 10px rgba(0, 0, 0, 0.5)",
        }}
      >
        <h1 style={{ fontSize: "2.5rem", marginBottom: "1rem", color: darkMode ? "#FFFFFF" : "#000000" }}>
          Welkom bij mijn portfolio
        </h1>
        <div style={{ fontSize: "1.2rem", marginBottom: "2rem", lineHeight: "1.6" }}>
          <p>
            Ik ben Joppe Dierckx, een gepassioneerde applicatieontwikkelaar met
            een grote interesse in IT. Sinds mijn afstuderen in januari 2025 heb
            ik meer dan één jaar professionele ervaring opgebouwd als Progress
            OpenEdge Developer.
          </p>

          <p>
            Op deze portfoliowebsite ontdek je meer over mij, mijn technische
            vaardigheden en de projecten die ik met succes heb gerealiseerd. Ik
            sta open voor het leren en toepassen van nieuwe programmeertalen,
            frameworks en technologieën. Dankzij mijn leergierigheid en analytisch
            denkvermogen maak ik nieuwe ontwikkelomgevingen snel eigen en ga ik
            met enthousiasme elke technische uitdaging aan.
          </p>

          <p style={{ marginBottom: 0 }}>
            Ik blijf mezelf voortdurend ontwikkelen en kijk ernaar uit om mijn
            kennis en ervaring verder uit te breiden binnen een uitdagende en
            innovatieve IT-omgeving.
          </p>
        </div>
        <div className="text-center mt-4">
          <div className="mt-3">
            <a
              href="https://github.com/JoppeDierckx"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary me-2"
            >
              Github
            </a>
            <a
              href="https://www.linkedin.com/in/joppe-dierckx-aa8776251/"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-secondary"
            >
              LinkedIn
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Welcome;
